export enum GroupWizardSteps {
    DETAILS = 'details',
    AGENTS = 'agents',
    APPLICATION = 'application',
    SETTINGS = 'settings'
}
